import React from "react";
import { Checkbox, FormControlLabel, withStyles } from "@material-ui/core";

const styles = (theme: any) => ({
  formControlLabel: {
    margin: 0,
  },
  checkbox: {
    padding: 4,
    color: theme.iconColor,
    "&.Mui-checked": {
      color: theme.primaryColor,
    },
  },
  label: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
    lineHeight: "16px",
  },
  disabled: {
    color: theme.ToggleDisableIconColor,
    "& $checkbox": {
      color: theme.ToggleDisableIconColor,
    },
    "& $label": {
      color: theme.ToggleDisableIconColor,
    },
  },
});

interface LabeledCheckboxProps {
  checked: boolean;
  disabled?: boolean;
  label: React.ReactNode;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  classes: Record<string, string>;
}

const LabeledCheckboxComponent: React.FC<LabeledCheckboxProps> = ({
  checked,
  disabled = false,
  label,
  onChange,
  name,
  classes,
}) => {
  return (
    <FormControlLabel
      classes={{
        root: classes.formControlLabel,
        label: classes.label,
        disabled: classes.disabled,
      }}
      disabled={disabled}
      control={
        <Checkbox
          classes={{
            root: classes.checkbox,
            disabled: classes.disabled,
          }}
          checked={checked}
          onChange={onChange}
          name={name}
          color="primary"
        />
      }
      label={label}
    />
  );
};

export const LabeledCheckbox = withStyles(styles)(LabeledCheckboxComponent);
